import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_CONTRACT_DOWNLOAD_PATH,
  GetOrganizationContractDownloadSuccessDto,
} from '@/api/rest/resources/types/organization';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type DownloadResult = GetOrganizationContractDownloadSuccessDto;

export const useContractDownload = () => {
  const orgId = useOrganizationId();

  assertIsDefined(orgId, 'organizationId');

  const downloadContract = async (contractId: string) => {
    const pathParams = { organization_id: orgId, contract_id: contractId };
    const response = await getRequest<DownloadResult>(GET_ORGANIZATION_CONTRACT_DOWNLOAD_PATH, pathParams);

    if (response.file_url) {
      window.open(response.file_url, '_blank');
    }
  };

  return { downloadContract };
};
